import axios from 'axios';
import europeanCountries from './europeanCountries';
/**
 * Custom hook to fetch country code information based on the provided postal code.
 * @hook
 *
 * @param {string} country - The country code.
 * @returns {Object} - An object containing the handleCountryCodeInfos function.
 */
export const useCountryCodeInfos = (country) => {
  /**
   * Fetches city and state information based on the provided postal code.
   * @param {string} postalCode - The postal code.
   * @returns {Promise<Object>} - A promise that resolves to an object containing the city and state information.
   */
  const handleCountryCodeInfos = (postalCode) => {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${postalCode}&components=country:${europeanCountries[country]}&key=${process.env.REACT_APP_GOOGLE_MAP_API}`;

    return axios
      .get(url)
      .then((response) => {
        const result = response.data.results[0];

        const state = result.address_components.find((component) =>
          component.types.includes('administrative_area_level_2')
        )?.long_name;

        const cities = result.postcode_localities || [];

        const city = result.address_components.find((component) =>
          component.types.includes('locality')
        )?.long_name;

        return { cities, city, state };
      })
      .catch(() => ({ cities: [], city: '', state: '' }));
  };

  return { handleCountryCodeInfos };
};
